import { sourceAnotherOption, sourceOnlineSchoolOption } from './constants';

export const createInformationSourceValue = (informationSource, source, sourceOnlineSchool) => {
  switch (informationSource) {
    case sourceAnotherOption:
      return `${informationSource}: ${source}`;
    case sourceOnlineSchoolOption:
      return `${informationSource}: ${sourceOnlineSchool}`;

    default:
      return informationSource;
  }
};
